import {
  Container,
  Stack,
  Box,
  Text,
  HStack,
  Divider,
  useColorModeValue,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import t from "../translations";

const MotionBox = motion(Box);

export default function About() {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.15 });
  const textColor = useColorModeValue("gray.600", "gray.400");

  return (
    <Container maxW="4xl" id="about" py={{ base: 16, md: 24 }}>
      <Stack spacing={{ base: 6, md: 10 }}>
        <Stack align="center" direction="row" px={4}>
          <HStack mx={4}>
            <Text fontWeight={800} fontSize={{ base: "xl", md: "2xl" }} whiteSpace="nowrap">
              {t.about.heading}
            </Text>
          </HStack>
          <Divider />
        </Stack>
        <MotionBox
          ref={ref}
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, ease: "easeOut" }}
          px={4}
        >
          <Text color={textColor} fontSize="lg" lineHeight={1.8}>
            {t.about.description}
          </Text>
        </MotionBox>
      </Stack>
    </Container>
  );
}
